import React, { useEffect } from "react";
import styles from "../Professionals/Professionals.module.css";
import { useNavigate } from "react-router-dom";
const Professionals = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.charset = "utf-8";
    script.type = "text/javascript";
    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "19647191",
          formId: "dc5ae05f-bd2f-4c99-99cb-7f8e80f94362",
          region: "na1",
          target: "#hubspotForm",
          css: "", // we are injecting custom CSS
        });
      }
    };
    document.body.appendChild(script);

    const style = document.createElement("style");
    style.innerHTML = `
  /* Input Labels */
  #hubspotForm .hs-form-field > label {
    color: #00758d !important;
    font-weight:600;
    margin-bottom: 5px;
    display: block;
    margin-top:12px !important;
    font-size:17px;
  font-family: Open Sans;
  }


#hubspotForm .hs-form-field.field.hs_type_of_practice_specialty > label {
  margin-top: 22px !important; 
  margin-bottom: -9px !important;
}
  /* General input styles */
  #hubspotForm input[type="text"],
  #hubspotForm input[type="email"],
  #hubspotForm input[type="tel"],
  #hubspotForm input[type="number"],
  #hubspotForm textarea,
  #hubspotForm select {
    border: 1px solid #00a7e1 !important;
    border-radius: 4px;
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    color: #000 !important; 
    font-size: 16px !important;
    font-weight: normal;
    line-height: 22px;
    background-color: #f5f8fa !important;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  /* Placeholder color */
  #hubspotForm input::placeholder,
  #hubspotForm textarea::placeholder {
    color: #000 !important;
    opacity: 1 !important;
  }

  #hubspotForm input[type="text"]:focus,
  #hubspotForm input[type="email"]:focus,
  #hubspotForm textarea:focus,
  #hubspotForm select:focus {
    outline: none;
    border-color: #00758d !important;
    box-shadow: 0 0 0 2px rgba(0, 167, 225, 0.2);
  }

  /* Checkbox container - 2 column layout */
  #hubspotForm .inputs-list.multi-container {
    display: flex;
    flex-wrap: wrap;
    gap:0px;
    padding-left: 0;
    margin-top: 0px;
  }

  #hubspotForm .inputs-list.multi-container .hs-form-checkbox {
    width: 50%;
    margin-bottom: -8px;
    margin-top:0px;
    list-style: none !important;
  }
    #hubspotForm .hs-form-field.hs_message textarea {
  width: 100% !important;
  min-height: 55px; 
}

  /* Remove bullet markers from checkboxes */
  #hubspotForm .hs-form-checkbox::marker {
    display: none;
    content: "";
  }

  @media (max-width: 600px) {
    #hubspotForm .inputs-list.multi-container .hs-form-checkbox {
      width: 100%;
    }
  }

  /* Checkbox styles */
  #hubspotForm input[type="checkbox"] {
    accent-color: #00758d;
    cursor: pointer;
top: 1px;
margin-top:20px;
  }

 
    #hubspotForm .hs-form-checkbox-display span {
  color: #00758d;
  font-weight: 500;
  margin-left: 8px;  
}

  /* Submit button styling */
  #hubspotForm input[type="submit"] {
    background-color: #00758d !important;
    color: white !important;
    padding: 10px 20px;
    border: none;
    margin-top:17px;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  #hubspotForm input[type="submit"]:hover {
    background-color: #007fb1 !important;
  }
    #hubspotForm .hs-form-field.hs_message {
  margin-top: 23px !important;
}

  /* Error message styling */
  #hubspotForm .hs-error-msgs {
    margin-top: 16px !important;
    color: red !important;
    font-size: 13px;
    list-style: none !important;
    padding-left: 0 !important;
    display: block !important;
    clear: both !important;
  }

  #hubspotForm .hs-error-msgs li {
    display: inline-block;
    padding: 0;
    margin: 0;
  }

  #hubspotForm .hs-error-msgs label,
  #hubspotForm .hs-error-msgs li label {
    color: red !important;
    font-size: 13px !important;
  }

  #hubspotForm .hs_type_of_practice_specialty .hs-error-msgs {
    margin-top: 20px !important;
  }

  #hubspotForm .hs-form-required {
    color: red !important;
  }

  /* Checkbox styles */
  #hubspotForm input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid #cbd6e2;
    border-radius: 4px;
    position: relative;
    cursor: pointer;
    margin-top: 20px;
    background-color: white;
  }

  /* Checked state - blue background */
  #hubspotForm input[type="checkbox"]:checked {
    background-color: #00758d;
    border-color: #00758d;
  }

  /* White tick */
  #hubspotForm input[type="checkbox"]:checked::after {
    content: "";
    position: absolute;
    left: 3px;
    top: -1px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    pointer-events: none;
  }

/* Checkbox label text */
#hubspotForm .hs-form-checkbox-display span {
  color: #00758d;
  font-weight: 500;
  margin-left: 8px;
}
div[class^="Professionals_hubspotdiv"] a {
  color: #00a7e1 !important;
  font-weight: 600 !important;
  text-decoration: none !important;
  word-break: break-all !important;
}

  /* Special characters only (/, &, -, (, )) receive clean font and zero margin/padding */
  #hubspotForm .hs-sep-char,
  .hs-sep-char {
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    font-style: normal !important;
    font-weight: inherit !important;
    display: inline !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  div[class^="Professionals_hubspotdiv"] a {
    color: #00a7e1 !important;
    font-weight: 600 !important;
    text-decoration: none !important;
  }
`;

    document.head.appendChild(style);

    const wrapSpecialChars = (container) => {
      // Sirf wahi symbols jinke demo font mein tree icons aate hain (/, &, -, (, ))
      // Comma (,) aur dot (.) normal text hain aur unhe wrap nahi karna
      const specialCharRegex = /([/&()\-–—*+®™©])/;

      const labels = container.querySelectorAll(
        ".hs-form-checkbox-display > span, .hs-form-radio-display > span, .hs-form-booleancheckbox-display > span",
      );

      labels.forEach((labelSpan) => {
        if (labelSpan.dataset.sepWrapped) return;

        const childNodes = Array.from(labelSpan.childNodes);

        childNodes.forEach((node) => {
          if (node.nodeType !== Node.TEXT_NODE) return;
          if (!specialCharRegex.test(node.textContent)) return;

          const parts = node.textContent.split(specialCharRegex);
          const fragment = document.createDocumentFragment();

          parts.forEach((part) => {
            if (part === "") return;
            if (specialCharRegex.test(part) && part.length === 1) {
              const span = document.createElement("span");
              span.className = "hs-sep-char";
              span.textContent = part;
              fragment.appendChild(span);
            } else {
              fragment.appendChild(document.createTextNode(part));
            }
          });

          labelSpan.replaceChild(fragment, node);
        });

        labelSpan.dataset.sepWrapped = "true";
      });
    };

    const observer = new MutationObserver(() => {
      const container = document.querySelector(
        'div[class^="Professionals_hubspotdiv"]',
      );
      if (!container) return;

      try {
        observer.disconnect();

        const links = container.querySelectorAll("a");
        links.forEach((link) => {
          if (link.innerHTML.includes('"')) {
            link.innerHTML = link.innerHTML.replace(/"/g, "");
          }
        });

        wrapSpecialChars(container);
      } catch (e) {
        // silently ignore
      } finally {
        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      if (style.parentNode) {
        document.head.removeChild(style);
      }
      observer.disconnect();
    };
  }, []);

  // const handleDownload = () => {
  //   const files = [
  //     {
  //       href: "/Pdf/Fusiontechnology-flyer-03-Interactive.pdf",
  //       name: "Fusiontechnology-flyer-03-Interactive.pdf",
  //     },
  //     // { href: "/Pdf/Fusiontechnology-flyer-02-Interactive.pdf", name: "Fusiontechnology-flyer-02-Interactive.pdf" },
  //   ];

  //   files.forEach((file, index) => {
  //     setTimeout(() => {
  //       const link = document.createElement("a");
  //       link.href = file.href;
  //       link.download = file.name;
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     }, index * 500);
  //   });
  // };

  return (
    <>
      <div className={styles.BackBtnDiv}>
        <div className={styles.backBtn} onClick={() => navigate(-1)}>
          <svg
            width="18"
            height="15"
            viewBox="0 0 18 15"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.252011 8.20052L5.8383 14.6871C6.15713 15.0254 6.82754 15.1466 7.19124 14.759C7.55373 14.3848 7.55373 13.6604 7.19124 13.2729L3.08873 8.52662L17.0653 8.52662C17.5818 8.52662 18 8.06717 18 7.49988C18 6.9326 17.5817 6.47315 17.0653 6.47315L3.08873 6.47315L7.19 1.72555C7.55249 1.35132 7.57431 0.589615 7.19 0.239358C6.82751 -0.086909 6.16681 -0.098897 5.83706 0.323253L0.252011 6.79793C0.00955088 7.06428 -0.166247 7.75277 0.252011 8.1989V8.20052Z"
              fill="currentColor"
            />
          </svg>
          <h4>Back</h4>
        </div>
        {/* <div> <button className={styles.downloadBtn} onClick={handleDownload}>
          <span className={styles.downloadIcon}><img src="/svg/download-pdf-icon.svg" loading="lazy" decoding="async" /></span>
          <div>
            <span>AAO FusionTechnology<sup>™ </sup></span>
            <br />
            <span>Symposium Download</span>
          </div>
        </button></div> */}
      </div>

      <div className={styles.containerBox}>
        <div className={styles.container}>
          <div className={styles.LeftSection}>
            <div className={styles.eyeforwarImg}>
              <img
                src="Images/Professional2.webp"
                alt="active older adult using his phone by his car, symbolizing lifestyle freedom and patient confidence with Deseyne® contact lenses"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
          <div className={styles.RightSection}>
            <div className={styles.Content}>
              <div className={styles.bredcrumMain}>
                <div className={styles.bredcrum}>
                  <h5 className={styles.Rightheading}>For Professionals</h5>
                </div>
              </div>
              <h1 className={styles.title}>Advancing Vision Care</h1>
              <h3 className={styles.subtitle}>
                Partner with a company dedicated to developing innovative vision
                care products.
              </h3>
              <div className={styles.descriptions}>
                <p className={styles.dsec}>
                  Thank you for your interest in Deseyne® contact lenses. Our
                  professional service portal is coming soon, where you’ll find
                  fitting resources, training, and the latest updates on our
                  breakthrough technology.
                </p>
                <p className={styles.dsec}>
                  In the meantime, please leave your details below, and we’ll
                  keep you informed as we approach the launch.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.relativeDiv}>
          <div className={styles.hubspotdiv}>
            <div id="hubspotForm"></div>
          </div>
          {/* <div className={styles.pdfDownload2}>
            <button className={styles.downloadBtn} onClick={handleDownload}>
              <span className={styles.downloadIcon}><img src="/svg/download-pdf-icon.svg" loading="lazy" decoding="async" /></span>
              <div>
                <span>AAO FusionTechnology<sup>™</sup></span>
                <br />
                <span>Symposium Download</span>
              </div>
            </button>
          </div> */}
          <div className={styles.trackingDiv}>
            <img
              src="Images/eye-line-art.webp"
              alt="eye-line-art"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Professionals;
